// src/components/Menu.js

import React, { useState } from 'react';
import { menuItems } from '../data/menuData';
import '../styles/Menu.css';

function MenuCard({ product }) {
  return (
    <div className="menu-item-card">
      <img
        src={product.image_url || '/images/no-image.png'}   // fallback if no url
        alt={product.name}
        className="menu-item-image"
        loading="lazy"
      />

      <div className="menu-item-content">
        {product.tags?.includes('popular') && (
          <span className="badge popular">🔥 Popular</span>
        )}
        {product.tags?.includes('featured') && (
          <span className="badge featured">⭐ Featured</span>
        )}

        <h3>{product.name}</h3>
        <p className="menu-item-description">
          {product.description || 'A customer favorite'}
        </p>
      </div>
    </div>
  );
}

function Menu() {
  const [activeCategory, setActiveCategory] = useState(null);
  const [activeSubcategory, setActiveSubcategory] = useState(null);

  const featuredItems = menuItems.filter(
  (item) =>
    item.tags?.includes('popular') ||
    item.tags?.includes('featured')
);

  const CATEGORY_CONFIG = {
    coffee: ['hot', 'ice'],
    food: ['sandwich', 'toast', 'pastry'],
    drinks: [
      'juice',
      'soft',
      'energy',
      'beer',
      'water',
      'tea',
      'iced-tea',
    ],
    sweets: [],
    chocolate: ['iced', 'hot'],
    'energy-boost': [],
  };

  // 🔥 FILTER LOGIC
  const filteredProducts = menuItems.filter((product) => {
    if (!activeCategory) return true;

    if (activeSubcategory) {
      return product.category === `${activeCategory}-${activeSubcategory}`;
    }

    return product.category.startsWith(activeCategory);
  });

  // 🔥 ONLY remove duplicates when NO filter is active
  const sectionedIds = new Set(
    menuItems
      .filter(
        (item) =>
          item.tags?.includes('popular') || item.tags?.includes('basic')
      )
      .map((item) => item.id)
  );

  const finalProducts =
    activeCategory || activeSubcategory
      ? filteredProducts // 👉 show everything when filtering
      : filteredProducts.filter((item) => !sectionedIds.has(item.id));

  // 🔥 SORT
  const sortedProducts = [...finalProducts].sort((a, b) => {
    const priority = (item) => {
      if (item.tags?.includes('popular')) return 1;
      if (item.tags?.includes('featured')) return 2;
      if (item.tags?.includes('basic')) return 3;
      return 4;
    };
    return priority(a) - priority(b);
  });

  return (
    <div className="menu-container">

      {/* 🔥 FILTER UI (ALWAYS VISIBLE) */}
      <div className="menu-header">
        <div className="category-row">
          {Object.keys(CATEGORY_CONFIG).map((category) => (
            <button
              key={category}
              className={`category-btn ${
                activeCategory === category ? 'active' : ''
              }`}
              onClick={() => {
                setActiveCategory(category);
                setActiveSubcategory(null);
              }}
            >
              {category.replace('-', ' ')}
            </button>
          ))}

          <button
            className={`category-btn ${!activeCategory ? 'active' : ''}`}
            onClick={() => {
              setActiveCategory(null);
              setActiveSubcategory(null);
            }}
          >
            ⭐ Featured
          </button>
        </div>

        {activeCategory &&
          CATEGORY_CONFIG[activeCategory].length > 0 && (
            <div className="subcategory-row">
              {CATEGORY_CONFIG[activeCategory].map((sub) => (
                <button
                  key={sub}
                  className={`subcategory-btn ${
                    activeSubcategory === sub ? 'active' : ''
                  }`}
                  onClick={() => setActiveSubcategory(sub)}
                >
                  {sub.replace('-', ' ')}
                </button>
              ))}
            </div>
          )}
      </div>

      {/* 🔥 MAIN MENU */}
      <h1>
        {activeCategory ? activeCategory.replace('-', ' ') : 'Featured'}
      </h1>

      <div className="menu-grid">
        {(!activeCategory ? featuredItems : sortedProducts).length === 0 ? (
          <p>No items available at the moment ☕</p>
        ) : (
          (!activeCategory ? featuredItems : sortedProducts).map((product) => (
            <MenuCard key={product.id} product={product} />
          ))
        )}
      </div>
    </div>
  );
}

export default Menu;